<span #container [class]="styleClass" [style]="style">
  <p-inputMask
    [styleClass]="'basin-width-100'"
    mask="99:99"
    placeholder="00:00"
    slotChar="00:00"
    characterPattern="[0-9]"
    [ngModel]="displayValue"
    (ngModelChange)="parseDisplayValue($event)"
    [disabled]="disabled"
    [readonly]="readonly"
    (onFocus)="onInputFocus($event)"
    (click)="onInputClick()"
    (onBlur)="onInputBlur($event)"
  ></p-inputMask>
  <div
    #contentWrapper
    [ngClass]="{
      'p-datepicker p-component basin-position-relative': true,
      'p-datepicker-inline': inline,
      'p-disabled': disabled,
    }"
    [@overlayAnimation]="{
      value: 'visible',
      params: {
        showTransitionParams: '.12s cubic-bezier(0, 0, 0.2, 1)',
        hideTransitionParams: '.1s linear'
      }
    }"
    [@.disabled]="inline === true"
    (@overlayAnimation.start)="onOverlayAnimationStart($event)"
    (@overlayAnimation.done)="onOverlayAnimationDone($event)"
    *ngIf="inline || overlayVisible"
  >
    <div class="p-timepicker">
      <div class="p-minute-picker">
        <div class="basin-subtitle-small basin-text-align-center">Minutes</div>
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (keydown.enter)="incrementMinute($event)"
          (keydown.space)="incrementMinute($event)"
          (mousedown)="onTimePickerElementMouseDown($event, 1, 1)"
          (mouseup)="onTimePickerElementMouseUp($event)"
          (keyup.enter)="onTimePickerElementMouseUp($event)"
          (keyup.space)="onTimePickerElementMouseUp($event)"
          (mouseleave)="onTimePickerElementMouseLeave()"
          pRipple
        >
          <span class="icon-keyboard-arrow-up basin-font-size-24"></span>
        </button>
        <span>{{ this.pad(this.displayMinutes, 2) }}</span>
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (keydown.enter)="decrementMinute($event)"
          (keydown.space)="decrementMinute($event)"
          (mousedown)="onTimePickerElementMouseDown($event, 1, -1)"
          (mouseup)="onTimePickerElementMouseUp($event)"
          (keyup.enter)="onTimePickerElementMouseUp($event)"
          (keyup.space)="onTimePickerElementMouseUp($event)"
          (mouseleave)="onTimePickerElementMouseLeave()"
          pRipple
        >
          <span class="icon-keyboard-arrow-down basin-font-size-24"></span>
        </button>
      </div>
      <div class="p-separator">
        <span>:</span>
      </div>
      <div class="p-second-picker">
        <div class="basin-subtitle-small basin-text-align-center">Seconds</div>
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (keydown.enter)="incrementSecond($event)"
          (keydown.space)="incrementSecond($event)"
          (mousedown)="onTimePickerElementMouseDown($event, 2, 1)"
          (mouseup)="onTimePickerElementMouseUp($event)"
          (keyup.enter)="onTimePickerElementMouseUp($event)"
          (keyup.space)="onTimePickerElementMouseUp($event)"
          (mouseleave)="onTimePickerElementMouseLeave()"
          pRipple
        >
          <span class="icon-keyboard-arrow-up basin-font-size-24"></span>
        </button>
        <span>{{ this.pad(this.displaySeconds, 2) }}</span>
        <button
          class="p-link"
          type="button"
          (keydown)="onContainerButtonKeydown($event)"
          (keydown.enter)="decrementSecond($event)"
          (keydown.space)="decrementSecond($event)"
          (mousedown)="onTimePickerElementMouseDown($event, 2, -1)"
          (mouseup)="onTimePickerElementMouseUp($event)"
          (keyup.enter)="onTimePickerElementMouseUp($event)"
          (keyup.space)="onTimePickerElementMouseUp($event)"
          (mouseleave)="onTimePickerElementMouseLeave()"
          pRipple
        >
          <span class="icon-keyboard-arrow-down basin-font-size-24"></span>
        </button>
      </div>
    </div>
  </div>
</span>
